import { IChartBackendService, ISorter, RawChartDataLike, ChartConfigLike } from "./types";

export class PieChartBackendServiceTS {
  private readonly chartBackendService: IChartBackendService;
  private readonly sorter: ISorter;

  constructor(chartBackendService: IChartBackendService, sorter: ISorter) {
    this.chartBackendService = chartBackendService;
    this.sorter = sorter;
  }

  async fetchJson(tableId: string | number, filter: any, config: any, isBiView?: boolean): Promise<any> {
    return this.chartBackendService.fetchJson(tableId, filter, config, isBiView);
  }

  getRepresentation(resultData: RawChartDataLike, _config?: ChartConfigLike) {
    const categoryType = resultData.config.key.data_type;
    const valueType = resultData.config.values.data_type;

    const categoryParser = this.chartBackendService.getParserForType(categoryType);
    const valueParser = this.chartBackendService.getParserForType(valueType);

    let data = this.chartBackendService
      .nest()
      .key(d => categoryParser(d.key))
      .rollup((array: any[]) => {
        if (array.length > 1) throw new Error("Error: Found multiple data points for single category combination.");
        return valueParser(array[0].values[0]);
      })
      .excludeNullKeys(true)
      .entries(resultData.values);

    // Stable sort by category first
    data = this.sorter.sort(data, {
      dataType: categoryType,
      valueParser: (item: any) => item.key,
    });
    // Then by value in descending order
    data = this.sorter.sort(data, {
      dataType: "numeric",
      order: "desc",
      valueParser: (item: any) => item.values,
    });

    return data;
  }
}

export function createAngularCompatiblePieService(chartBackendService: IChartBackendService, sorter: ISorter) {
  const service = new PieChartBackendServiceTS(chartBackendService, sorter);
  return {
    fetchJson: service.fetchJson.bind(service),
    getRepresentation: service.getRepresentation.bind(service),
  };
}


